/**
*
* TemplateFilterSwitch
*
*/

import React from 'react';
import onClickOutside from 'react-onclickoutside';


import Tag from 'components/Tag';
import IconHolder from 'components/Icons/IconHolder';

import TemplateFilterSwitchButton from './styles/TemplateFilterSwitchButton';
import TemplateFilterSwitchListWrapper from './styles/TemplateFilterSwitchListWrapper';

import TemplateFilterSwitchTagsWrapper from './styles/TemplateFilterSwitchTagsWrapper';
import TemplateFilterSwitchWrapper from './styles/TemplateFilterSwitchWrapper';
import filterIcon from 'assets/allIcons/ui/icon_ui_filter.svg'


export class TemplateFilterSwitch extends React.Component {
  constructor() {
    super();

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleFiltersSwitch = this.handleFiltersSwitch.bind(this);

    this.state = {
      areFiltersOpen: false,
    };
  }

  handleClickOutside() {
    if (this.state.areFiltersOpen) {
      this.handleFiltersSwitch(true);
    }

  }

  handleFiltersSwitch(isClose) {
    this.setState(prevState => {
      return { areFiltersOpen: typeof isClose === 'boolean' ? false : !prevState.areFiltersOpen }
    })
  }


  render() {

    const {
      activeFiltersNumber,
      availableFilters,
      selectedFilters,
      handleFilterClick,
      enableFilters,
      commonProps,
      typeOfStyle,
      customStyles = {},
      thisStylesWrapper,
      switchButtonThisStyles,
      switchListThisStyles
    } = this.props;

    const {
      areFiltersOpen
    } = this.state;

    const {
      windowWidth
    } = commonProps;


    let dropdownBackgroundColor = customStyles.backgroundColor;

    let headline_font_color = customStyles.textColor;

    let switchColor = customStyles.textColor;
    let switchColorActive = customStyles.textColor;
    let switchColorHover = customStyles.textColor;

    let switchBackground = customStyles.buttonColor;
    let switchBackgroundActive = customStyles.primaryColor;
    let switchBackgroundHover = customStyles.primaryActiveColor;


    const thisStyling = this.props?.commonProps?.styling?.tagsStyling;

    if (thisStyling) {
      if (thisStyling['0'] && (!windowWidth || windowWidth === '0' || windowWidth === '37_5' || windowWidth === '76_8')) {
        if (thisStyling['0']?.headline_font_color) headline_font_color = thisStyling['0']?.headline_font_color;
        if (thisStyling['0']?.tags_dropdown_background) dropdownBackgroundColor = thisStyling['0']?.tags_dropdown_background;
        if (thisStyling['0']?.switch_color) switchColor = thisStyling['0']?.switch_color;
        if (thisStyling['0']?.switch_color_active) switchColorActive = thisStyling['0']?.switch_color_active;
        if (thisStyling['0']?.switch_color_hover) switchColorHover = thisStyling['0']?.switch_color_hover;
        if (thisStyling['0']?.switch_background) switchBackground = thisStyling['0']?.switch_background;
        if (thisStyling['0']?.switch_background_active) switchBackgroundActive = thisStyling['0']?.switch_background_active;
        if (thisStyling['0']?.switch_background_hover) switchBackgroundHover = thisStyling['0']?.switch_background_hover;
      }
      if (thisStyling['76_8'] && (windowWidth === '37_5' || windowWidth === '76_8')) {
        if (thisStyling['76_8']?.headline_font_color) headline_font_color = thisStyling['76_8']?.headline_font_color;
        if (thisStyling['76_8']?.tags_dropdown_background) dropdownBackgroundColor = thisStyling['76_8']?.tags_dropdown_background;
        if (thisStyling['76_8']?.switch_color) switchColor = thisStyling['76_8']?.switch_color;
        if (thisStyling['76_8']?.switch_color_active) switchColorActive = thisStyling['76_8']?.switch_color_active;
        if (thisStyling['76_8']?.switch_color_hover) switchColorHover = thisStyling['76_8']?.switch_color_hover;
        if (thisStyling['76_8']?.switch_background) switchBackground = thisStyling['76_8']?.switch_background;
        if (thisStyling['76_8']?.switch_background_active) switchBackgroundActive = thisStyling['76_8']?.switch_background_active;
        if (thisStyling['76_8']?.switch_background_hover) switchBackgroundHover = thisStyling['76_8']?.switch_background_hover;
      }
      if (thisStyling['37_5'] && windowWidth === '37_5') {
        if (thisStyling['37_5']?.headline_font_color) headline_font_color = thisStyling['37_5']?.headline_font_color;
        if (thisStyling['37_5']?.tags_dropdown_background) dropdownBackgroundColor = thisStyling['37_5']?.tags_dropdown_background;
        if (thisStyling['37_5']?.switch_color) switchColor = thisStyling['37_5']?.switch_color;
        if (thisStyling['37_5']?.switch_color_active) switchColorActive = thisStyling['37_5']?.switch_color_active;
        if (thisStyling['37_5']?.switch_color_hover) switchColorHover = thisStyling['37_5']?.switch_color_hover;
        if (thisStyling['37_5']?.switch_background) switchBackground = thisStyling['37_5']?.switch_background;
        if (thisStyling['37_5']?.switch_background_active) switchBackgroundActive = thisStyling['37_5']?.switch_background_active;
        if (thisStyling['37_5']?.switch_background_hover) switchBackgroundHover = thisStyling['37_5']?.switch_background_hover;
      }
    }

    if (!enableFilters) return;

    const isFiltersArray = availableFilters ? Array.isArray(availableFilters) : null;

    const filtersDisplayed = [];

    if (!isFiltersArray && availableFilters && Object.keys(availableFilters).length) {
      for (const [filterKey, valuesArray] of Object.entries(availableFilters)) {
        if (valuesArray && valuesArray.length) {

          const tagsArrayContent = valuesArray.map(value => {
            if (value) return (
              <Tag
                title={value.title ? value.title : value}
                key={`Calendar${filterKey}Filter-${value.tagId ? value.tagId : value}`}
                isActive={selectedFilters[filterKey]?.includes(value.tagId ? value.tagId : value)}
                thisDesktopStyles={{ width: 'fit-content', overflow: 'visible' }}
                onClick={() => handleFilterClick(value.tagId ? value.tagId : value, filterKey)}
                commonProps={commonProps}
                typeOfStyle={typeOfStyle}
                customStyles={customStyles}
                hoverOff={true}
                tagColor={switchColor}
                $hasPointer={true}
              />
            )
          }).filter(a => a);

          if (tagsArrayContent && tagsArrayContent.length) {
            filtersDisplayed.push(       
              <TemplateFilterSwitchTagsWrapper key={`Calendar${filterKey}FiltersTags`} $color={headline_font_color} $header={`${filterKey}:`}>
                {tagsArrayContent}
              </TemplateFilterSwitchTagsWrapper>
            )
          }
        }
      }
    } else if (isFiltersArray && availableFilters) {
            const tagsArrayContent = availableFilters.map(value => {
              if (value) return (
                <Tag
                  title={value.title ? value.title : value}
                  key={`CalendarTagsFilter-${value.tagId ? value.tagId : value}`}
                  isActive={selectedFilters?.includes(value.tagId ? value.tagId : value)}
                  thisDesktopStyles={{ width: 'fit-content', overflow: 'visible' }}
                  onClick={() => handleFilterClick(value)}
                  commonProps={commonProps}
                  typeOfStyle={typeOfStyle}
                  customStyles={customStyles}
                  hoverOff={true}
                  tagColor={'#1C1C1D'}
                  innerColor={'#F3F2F0'}
                  innerColorAcrive={'#FFF'}
                  $hasPointer={true}
                  tagWrapperThisStyles={`
                    border-radius: 0.3rem;
                    border: 0;
                  `}
                />
              )
            }).filter(a => a);
  
            if (tagsArrayContent && tagsArrayContent.length) {
              filtersDisplayed.push(       
                <TemplateFilterSwitchTagsWrapper key={`CalendarTagsFiltersTags`} $color={headline_font_color} $header={`Tags:`}>
                  {tagsArrayContent}
                </TemplateFilterSwitchTagsWrapper>
              )
            }
    }

    return (
      <TemplateFilterSwitchWrapper $thisStylesWrapper={thisStylesWrapper}>
        <TemplateFilterSwitchButton
          $backgroundColor={switchBackground}
          $activeFiltersColor={switchBackgroundActive}
          $hoverBackgroundColor={switchBackgroundHover}
          $active={activeFiltersNumber}
          onClick={this.handleFiltersSwitch}
          $color={switchColor}
          $colorHover={switchColorHover}
          $colorActive={switchColorActive}
          $switchButtonThisStyles={switchButtonThisStyles}
        >
          {activeFiltersNumber ? activeFiltersNumber : <IconHolder icon={filterIcon} />}
        </TemplateFilterSwitchButton>
        <TemplateFilterSwitchListWrapper
          $active={areFiltersOpen}
          $backgroundColor={dropdownBackgroundColor}
          $color={switchColor}
          $switchListThisStyles={switchListThisStyles}
        >
          {filtersDisplayed.length ? filtersDisplayed : 'Nothing to filter...'}
        </TemplateFilterSwitchListWrapper>
      </TemplateFilterSwitchWrapper>
    );
  }
}


export default onClickOutside(TemplateFilterSwitch);
